/**
 * Tooltip initialisation and usage
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


const OPT = 'ts-large';


injector.injectClass(class extends Script {
    onLoad() {
        const $body = $('body');

        if (localStorage.getItem(OPT)) {
            $body.addClass(OPT);
        }

        if ($body.hasClass(OPT)) {
            $('.text-size-widget > .large').addClass('selected');
        } else {
            $('.text-size-widget > .small').addClass('selected');
        }

        $('.text-size-widget > div').on('click', function () {
            const $this = $(this);
            const $parent = $this.parent();
            $parent.find('div').removeClass('selected');
            $this.addClass('selected');

            if ($this.hasClass('small')) {
                $body.removeClass(OPT);
                localStorage.removeItem(OPT);
            } else {
                $body.addClass(OPT);
                localStorage.setItem(OPT, true);
            }
        });
    }
});
